// src/components/pages/admin/PublicTimeCapsuleCMSPage.js
import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot
} from "firebase/firestore";
import { db } from "../../../firebase";
import {
  Box,
  Button,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import PublicTimeCapsuleForm from "./PublicTimeCapsuleForm";

const PublicTimeCapsuleCMSPage = () => {
  const [timeCapsules, setTimeCapsules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openForm, setOpenForm] = useState(false);
  const [editingCapsule, setEditingCapsule] = useState(null);

  useEffect(() => {
    const q = query(
      collection(db, "timeCapsules"),
      where("capsuleType", "!=", "private")
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const caps = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTimeCapsules(caps);
        setLoading(false);
      },
      (err) => {
        console.error("Error streaming time capsules:", err);
        setLoading(false);
      }
    );
    return unsubscribe;
  }, []);

  const handleCloseForm = () => {
    setEditingCapsule(null);
    setOpenForm(false);
  };

  // format a Firestore Timestamp as "Month day, year" in UTC
  const fmtDate = (ts) =>
    ts
      ? ts.toDate().toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
          timeZone: "UTC",
        })
      : null;

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" gutterBottom>
          Public Time Capsule Management
        </Typography>

        <Button
          variant="contained"
          onClick={() => {
            setEditingCapsule(null);
            setOpenForm(true);
          }}
          sx={(theme) => ({
            backgroundColor: theme.colors.blue,
            border: `1px solid ${theme.colors.blue}`,
            color: theme.colors.white,
            p: "10px 20px",
            textTransform: "none",
            borderRadius: "50px",
            mb: 2,
            boxShadow: "none",
            "&:hover": { boxShadow: "none" },
          })}
        >
          Create New Time Capsule
        </Button>

        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Paper sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Media</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Reveal Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {timeCapsules.map((capsule) => (
                  <TableRow key={capsule.id}>
                    <TableCell>
                      {capsule.media && capsule.media.length > 0 ? (
                        capsule.media[0].type === "image" ? (
                          <img
                            src={capsule.media[0].url}
                            alt="Capsule Media"
                            style={{
                              width: "150px",
                              aspectRatio: "16/9",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                          />
                        ) : (
                          <video
                            src={capsule.media[0].url}
                            controls
                            style={{
                              width: "150px",
                              aspectRatio: "16/9",
                              objectFit: "cover",
                              borderRadius: "10px",
                            }}
                          />
                        )
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                    <TableCell>{capsule.messageTitle}</TableCell>
                    <TableCell>{capsule.messageBody}</TableCell>
                    <TableCell>
                      {fmtDate(capsule.revealDate) || "Immediate"}
                    </TableCell>
                    <TableCell>
                      {fmtDate(capsule.endDate) || "No end date"}
                    </TableCell>
                    <TableCell>
                      {capsule.location?.address || "N/A"}
                    </TableCell>
                    <TableCell>{capsule.status || "N/A"}</TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setEditingCapsule(capsule);
                          setOpenForm(true);
                        }}
                        sx={(theme) => ({
                          backgroundColor: theme.colors.white,
                          border: `1px solid ${theme.colors.blue}`,
                          color: theme.colors.blue,
                          p: "10px 20px",
                          textTransform: "none",
                          borderRadius: "50px",
                          "&:hover": { boxShadow: "none" },
                        })}
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}

        <Dialog open={openForm} onClose={handleCloseForm} maxWidth="sm" fullWidth>
          <DialogTitle>
            {editingCapsule ? "Edit Time Capsule" : "Create New Public Time Capsule"}
          </DialogTitle>
          <DialogContent>
            <PublicTimeCapsuleForm
              onClose={handleCloseForm}
              refreshList={() => {}}
              initialData={editingCapsule}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
};

export default PublicTimeCapsuleCMSPage;
